/* hülya — apparitions au scroll. Aucun effet dans l'éditeur de thème ni si l'animation est réduite. */
(function () {
  var html = document.documentElement;
  if (html.classList.contains('shopify-design-mode')) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var CLS = 'hu-scrollin', IN = 'hu-scrollin--in';

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      io.unobserve(el);
      el.classList.add(IN);
      var wait = 900 + (parseInt(el.style.getPropertyValue('--hu-d'), 10) || 0);
      setTimeout(function () {
        el.classList.remove(CLS, IN);
        el.style.removeProperty('--hu-d');
      }, wait);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

  function mark(el, delay) {
    if (!el || el.classList.contains(CLS)) return;
    el.classList.add(CLS);
    if (delay) el.style.setProperty('--hu-d', delay + 'ms');
    io.observe(el);
  }

  function run() {
    var sections = document.querySelectorAll('main .shopify-section');
    Array.prototype.forEach.call(sections, function (sec, i) {
      if (i === 0) return;
      var wrap = null;
      for (var c = sec.firstElementChild; c; c = c.nextElementSibling) {
        if (c.tagName !== 'SCRIPT' && c.tagName !== 'STYLE' && c.tagName !== 'LINK') { wrap = c; break; }
      }
      if (!wrap) return;

      var cards = sec.querySelectorAll('.hu-grid > .hu-card');
      if (cards.length) {
        mark(sec.querySelector('.hu-pghead'), 0);
        Array.prototype.forEach.call(cards, function (card, n) { mark(card, Math.min(n, 7) * 80); });
      } else {
        mark(wrap, 0);
      }
    });
    html.classList.add('hu-js-reveal');

    /* sécurité : si un élément n'a jamais été révélé au bout de 4 s, on l'affiche quand même */
    setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('.' + CLS), function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) { el.classList.add(IN); }
      });
    }, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();